import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_TRIALITEMIMPORT_LOAD_BY_ID,
    ACTION_TRIALITEMIMPORT_LOAD_FAILURE,
    ACTION_TRIALITEMIMPORT_LOAD_SUCCESS,

    ACTION_TRIALITEMIMPORT_SAVE,
    ACTION_TRIALITEMIMPORT_SAVE_SUCCESS,
    ACTION_TRIALITEMIMPORT_SAVE_FAILURE,

    ACTION_TRIALITEMIMPORT_CLEAR,
    ACTION_TRIALITEMIMPORT_FILTER,

    TrialItemImportAction
} from '../actions/trialItemImport';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ITrialItemImportState {
    formData: Dtos.TrialItemImport,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.Trial[];
    formLength: number;
}

const initialState: ITrialItemImportState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};


function loading(state: ITrialItemImportState, _isLoading: boolean): ITrialItemImportState {
    const newState: ITrialItemImportState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: ITrialItemImportState,
    formData: Dtos.TrialItemImport,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialItemImportState {
    const newState: ITrialItemImportState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: ITrialItemImportState, formFilter: IFormFilter): ITrialItemImportState {
    /*
    const trials: Dtos.Trial[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = trials ? trials.length : 0;

    const formFilteredData = trials ? trials.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || p.display.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;
    */
    const newState: ITrialItemImportState = update(state, {
        formFilter: {
            $set: formFilter
        },
        //formFilteredData: {
        //    $set: formFilteredData
        //},
        //formLength: {
        //    $set: formLength
        //}
    });

    return newState;
}

function loadFailure(state: ITrialItemImportState, responseStatus: Dtos.ResponseStatus): ITrialItemImportState {
    const newState: ITrialItemImportState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: ITrialItemImportState, propertiesToClear?: string[]): ITrialItemImportState {

    if (!propertiesToClear) {
        const newState: ITrialItemImportState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: ITrialItemImportState, _isSaving: boolean): ITrialItemImportState {
    const newState: ITrialItemImportState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ITrialItemImportState,
    formData: Dtos.TrialItemImport,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialItemImportState {
    const newState: ITrialItemImportState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: ITrialItemImportState, responseStatus: Dtos.ResponseStatus): ITrialItemImportState {
    const newState: ITrialItemImportState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

const TrialItemImportReducer: Reducer<ITrialItemImportState> = (state: ITrialItemImportState = initialState, action: TrialItemImportAction) => {
    switch (action.type) {
        case ACTION_TRIALITEMIMPORT_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_TRIALITEMIMPORT_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALITEMIMPORT_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALITEMIMPORT_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TRIALITEMIMPORT_SAVE:
            return saving(state, true);
        case ACTION_TRIALITEMIMPORT_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALITEMIMPORT_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_TRIALITEMIMPORT_FILTER:
            return filter(state, action.formFilter);
    }

    return state;
}

export default TrialItemImportReducer;